(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gs-address-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gs-address-product')) {
    class GSAddressProduct extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;
        this.dataset.ready = 'true';

        const variantsNode = this.querySelector('[data-gs-variants]');
        try {
          this.variants = JSON.parse(variantsNode?.textContent || '[]');
        } catch (_error) {
          this.variants = [];
        }

        this.optionInputs = [...this.querySelectorAll('[data-gs-option-input]')];
        this.variantIdInput = this.querySelector('[data-gs-variant-id]');
        this.price = this.querySelector('[data-gs-price]');
        this.comparePrice = this.querySelector('[data-gs-compare-price]');
        this.sku = this.querySelector('[data-gs-sku]');
        this.inventory = this.querySelector('[data-gs-inventory]');
        this.addButton = this.querySelector('[data-gs-add-button]');
        this.addLabel = this.querySelector('[data-gs-add-label]');
        this.track = this.querySelector('[data-gs-media-track]');
        this.media = [...this.querySelectorAll('[data-gs-media]')];
        this.mediaTargets = [...this.querySelectorAll('[data-gs-media-target]')];
        this.zoomTriggers = [...this.querySelectorAll('[data-gs-zoom-trigger]')];
        this.zoomDialog = this.querySelector('[data-gs-zoom-dialog]');
        this.zoomImage = this.querySelector('[data-gs-zoom-image]');
        this.zoomClose = this.querySelector('[data-gs-zoom-close]');
        this.lastZoomTrigger = null;
        this.pinchMedia = [...this.querySelectorAll('[data-gs-pinch-media]')];
        this.pinchStates = new WeakMap();
        this.mobileMediaQuery = window.matchMedia('(max-width: 989px)');

        this.optionInputs.forEach((input) => {
          input.addEventListener('change', () => this.handleOptionChange(input));
        });

        this.querySelectorAll('[data-gs-quantity]').forEach((quantity) => {
          const input = quantity.querySelector('[data-gs-quantity-input]');
          quantity.querySelector('[data-gs-quantity-minus]')?.addEventListener('click', () => {
            this.changeQuantity(input, -1);
          });
          quantity.querySelector('[data-gs-quantity-plus]')?.addEventListener('click', () => {
            this.changeQuantity(input, 1);
          });
        });

        this.mediaTargets.forEach((target) => {
          target.addEventListener('click', () => this.activateMedia(String(target.dataset.gsMediaTarget), true));
        });

        this.querySelector('[data-gs-gallery-previous]')?.addEventListener('click', () => this.stepMedia(-1));
        this.querySelector('[data-gs-gallery-next]')?.addEventListener('click', () => this.stepMedia(1));

        this.zoomTriggers.forEach((trigger) => {
          trigger.addEventListener('click', () => this.openZoom(trigger));
        });
        this.zoomClose?.addEventListener('click', () => this.closeZoom());
        this.zoomDialog?.addEventListener('click', (event) => {
          if (event.target === this.zoomDialog) this.closeZoom();
        });
        this.zoomDialog?.addEventListener('close', () => {
          this.pinchMedia.forEach((media) => this.resetInlinePinch(media));
          this.lastZoomTrigger?.focus({ preventScroll: true });
        });

        this.pinchMedia.forEach((media) => {
          this.pinchStates.set(media, {
            scale: 1,
            panX: 0,
            panY: 0,
            initialDistance: 0,
            startScale: 1,
            startX: 0,
            startY: 0,
            startPanX: 0,
            startPanY: 0,
            isDragging: false,
            animationFrame: null
          });
          const touchOptions = { passive: false };
          media.addEventListener('touchstart', (event) => this.handleInlineTouchStart(event, media), touchOptions);
          media.addEventListener('touchmove', (event) => this.handleInlineTouchMove(event, media), touchOptions);
          media.addEventListener('touchend', (event) => this.handleInlineTouchEnd(event, media), touchOptions);
          media.addEventListener('touchcancel', (event) => this.handleInlineTouchEnd(event, media), touchOptions);
          media.addEventListener('gesturestart', (event) => event.preventDefault(), touchOptions);
          media.addEventListener('gesturechange', (event) => event.preventDefault(), touchOptions);
        });

        if (this.track) {
          let ticking = false;
          this.track.addEventListener(
            'scroll',
            () => {
              if (ticking) return;
              ticking = true;
              requestAnimationFrame(() => {
                this.syncMediaFromScroll();
                ticking = false;
              });
            },
            { passive: true }
          );
        }

        this.mobileMediaQuery.addEventListener?.('change', () => {
          requestAnimationFrame(() => this.updateMobileMediaHeight());
        });

        if ('ResizeObserver' in window) {
          this.mediaResizeObserver = new ResizeObserver(() => this.updateMobileMediaHeight());
          this.media.forEach((media) => this.mediaResizeObserver.observe(media));
        }

        requestAnimationFrame(() => this.updateMobileMediaHeight());
      }

      openZoom(trigger) {
        if (!this.zoomDialog || !this.zoomImage || typeof this.zoomDialog.showModal !== 'function') return;

        this.lastZoomTrigger = trigger;
        this.pinchMedia.forEach((media) => this.resetInlinePinch(media));
        this.zoomImage.src = trigger.dataset.gsZoomSrc || '';
        this.zoomImage.alt = trigger.dataset.gsZoomAlt || '';
        if (!this.zoomDialog.open) this.zoomDialog.showModal();
        requestAnimationFrame(() => {
          const zoomCanvas = this.pinchMedia[0];
          const state = zoomCanvas ? this.pinchStates.get(zoomCanvas) : null;
          if (state && this.mobileMediaQuery.matches) {
            state.scale = 1.5;
            this.renderInlinePinch(zoomCanvas, state);
          }
          this.zoomClose?.focus();
        });
      }

      closeZoom() {
        if (this.zoomDialog?.open) this.zoomDialog.close();
      }

      handleInlineTouchStart(event, media) {
        const state = this.pinchStates.get(media);
        if (!state) return;

        if (event.touches.length === 2) {
          event.preventDefault();
          const first = event.touches[0];
          const second = event.touches[1];
          if (!first || !second) return;

          state.initialDistance = this.getTouchDistance(first, second);
          state.startScale = state.scale;
          state.isDragging = false;
          media.classList.remove('is-panning');
          media.classList.add('is-pinching');
        } else if (event.touches.length === 1 && state.scale > 1.02) {
          event.preventDefault();
          const touch = event.touches[0];
          if (!touch) return;

          state.startX = touch.clientX;
          state.startY = touch.clientY;
          state.startPanX = state.panX;
          state.startPanY = state.panY;
          state.isDragging = true;
          media.classList.add('is-panning');
        }
      }

      handleInlineTouchMove(event, media) {
        const state = this.pinchStates.get(media);
        if (!state) return;

        if (event.touches.length === 2) {
          event.preventDefault();
          const first = event.touches[0];
          const second = event.touches[1];
          if (!first || !second || !state.initialDistance) return;

          const midpointX = (first.clientX + second.clientX) / 2;
          const midpointY = (first.clientY + second.clientY) / 2;
          const currentDistance = this.getTouchDistance(first, second);
          const oldScale = state.scale;
          state.scale = Math.min(5, Math.max(1, (currentDistance / state.initialDistance) * state.startScale));

          const rect = media.getBoundingClientRect();
          const distanceFromCenterX = midpointX - (rect.left + rect.width / 2);
          const distanceFromCenterY = midpointY - (rect.top + rect.height / 2);
          const scaleDelta = state.scale / oldScale - 1;

          state.panX -= (distanceFromCenterX * scaleDelta) / state.scale;
          state.panY -= (distanceFromCenterY * scaleDelta) / state.scale;
          state.isDragging = false;
          this.requestInlinePinchRender(media, state);
        } else if (event.touches.length === 1 && state.scale > 1.02 && state.isDragging) {
          event.preventDefault();
          const touch = event.touches[0];
          if (!touch) return;

          state.panX = state.startPanX + (touch.clientX - state.startX) / state.scale;
          state.panY = state.startPanY + (touch.clientY - state.startY) / state.scale;
          this.requestInlinePinchRender(media, state);
        }
      }

      handleInlineTouchEnd(event, media) {
        const state = this.pinchStates.get(media);
        if (!state) return;

        if (event.touches.length === 1 && state.scale > 1.02) {
          const touch = event.touches[0];
          if (touch) {
            state.startX = touch.clientX;
            state.startY = touch.clientY;
            state.startPanX = state.panX;
            state.startPanY = state.panY;
            state.isDragging = true;
            media.classList.add('is-panning');
          }
        } else if (event.touches.length === 0) {
          state.isDragging = false;
          state.initialDistance = 0;
          media.classList.remove('is-pinching', 'is-panning');
        }

        if (state.scale <= 1.02) this.resetInlinePinch(media);
        else this.requestInlinePinchRender(media, state);
      }

      getTouchDistance(first, second) {
        return Math.hypot(first.clientX - second.clientX, first.clientY - second.clientY);
      }

      requestInlinePinchRender(media, state) {
        if (state.animationFrame) return;
        state.animationFrame = requestAnimationFrame(() => {
          state.animationFrame = null;
          this.renderInlinePinch(media, state);
        });
      }

      constrainInlinePinch(media, state) {
        const image = media.querySelector('img');
        if (!image) return;

        state.scale = Math.min(5, Math.max(1, state.scale));
        if (state.scale <= 1) {
          state.scale = 1;
          state.panX = 0;
          state.panY = 0;
          return;
        }

        const rect = media.getBoundingClientRect();
        if (!rect.width || !rect.height) return;

        const naturalWidth = image.naturalWidth || rect.width;
        const naturalHeight = image.naturalHeight || rect.height;
        const imageRatio = naturalWidth / naturalHeight;
        const wrapperRatio = rect.width / rect.height;
        let fittedWidth;
        let fittedHeight;

        if (imageRatio > wrapperRatio) {
          fittedWidth = rect.width;
          fittedHeight = fittedWidth / imageRatio;
        } else {
          fittedHeight = rect.height;
          fittedWidth = fittedHeight * imageRatio;
        }

        const horizontalOverflow = Math.max(0, fittedWidth * state.scale - rect.width);
        const verticalOverflow = Math.max(0, fittedHeight * state.scale - rect.height);
        const maxPanX = horizontalOverflow / 2 / state.scale;
        const maxPanY = verticalOverflow / 2 / state.scale;

        state.panX = Math.min(maxPanX, Math.max(-maxPanX, state.panX));
        state.panY = Math.min(maxPanY, Math.max(-maxPanY, state.panY));
      }

      renderInlinePinch(media, state) {
        const image = media.querySelector('img');
        if (!image) return;

        this.constrainInlinePinch(media, state);
        image.style.transform = `scale(${state.scale}) translate3d(${state.panX}px, ${state.panY}px, 0)`;
        media.classList.toggle('is-pinch-zoomed', state.scale > 1.02);
      }

      resetInlinePinch(media) {
        const state = this.pinchStates.get(media);
        if (!state) return;

        if (state.animationFrame) cancelAnimationFrame(state.animationFrame);
        state.animationFrame = null;
        state.scale = 1;
        state.panX = 0;
        state.panY = 0;
        state.initialDistance = 0;
        state.startScale = 1;
        state.isDragging = false;
        media.classList.remove('is-pinching', 'is-panning', 'is-pinch-zoomed');
        const image = media.querySelector('img');
        if (image) image.style.transform = '';
      }

      handleOptionChange(changedInput) {
        const group = changedInput.closest('[data-gs-option-group]');
        const label = group?.querySelector('[data-gs-option-label]');
        if (label) label.textContent = changedInput.value;

        const selectedOptions = [...this.querySelectorAll('[data-gs-option-group]')]
          .sort((a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition))
          .map((optionGroup) => optionGroup.querySelector('[data-gs-option-input]:checked')?.value || '');

        const variant = this.variants.find(
          (candidate) =>
            candidate.options.length === selectedOptions.length &&
            candidate.options.every((option, index) => option === selectedOptions[index])
        );

        this.updateVariant(variant);
      }

      updateVariant(variant) {
        if (!variant) {
          if (this.addButton) this.addButton.disabled = true;
          if (this.addLabel) this.addLabel.textContent = this.dataset.unavailableLabel || 'Unavailable';
          return;
        }

        if (this.variantIdInput) {
          this.variantIdInput.value = variant.id;
          this.variantIdInput.dispatchEvent(new Event('change', { bubbles: true }));
        }

        if (this.price) this.price.textContent = variant.price;
        if (this.comparePrice) {
          this.comparePrice.textContent = variant.compareAtPrice || '';
          this.comparePrice.hidden = !variant.compareAtPrice;
        }

        if (this.sku) {
          const skuValue = this.sku.querySelector('span');
          if (skuValue) skuValue.textContent = variant.sku || '';
          this.sku.classList.toggle('is-hidden', !variant.sku);
        }

        this.updateInventory(variant);

        if (this.addButton) this.addButton.disabled = !variant.available;
        if (this.addLabel) {
          this.addLabel.textContent = variant.available
            ? this.dataset.addLabel || 'Add to cart'
            : this.dataset.soldOutLabel || 'Sold out';
        }

        if (variant.featuredMediaId) this.activateMedia(String(variant.featuredMediaId), true);

        if (this.dataset.updateUrl === 'true' && window.history?.replaceState) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url);
        }
      }

      updateInventory(variant) {
        if (!this.inventory) return;

        const threshold = Number(this.dataset.lowStockThreshold || 5);
        const exact = this.dataset.showExactInventory === 'true';
        const managed = variant.inventoryManagement === 'shopify';
        let text = this.inventory.dataset.inStockText || 'In stock';

        if (!variant.available) {
          text = this.inventory.dataset.outOfStockText || 'Out of stock';
        } else if (managed && variant.inventoryQuantity <= 0 && variant.inventoryPolicy === 'continue') {
          text = this.inventory.dataset.continueText || 'Available to order';
        } else if (managed && exact && variant.inventoryQuantity > 0) {
          text = `${variant.inventoryQuantity} ${variant.inventoryQuantity === 1 ? 'piece' : 'pieces'} in stock`;
        }

        this.inventory.textContent = text;
        this.inventory.classList.toggle('is-unavailable', !variant.available);
        this.inventory.classList.toggle(
          'is-low',
          variant.available && managed && variant.inventoryQuantity > 0 && variant.inventoryQuantity <= threshold
        );
      }

      changeQuantity(input, direction) {
        if (!input) return;
        const step = Number(input.step || 1);
        const min = Number(input.min || 1);
        const max = input.max ? Number(input.max) : Number.POSITIVE_INFINITY;
        const current = Number(input.value || min);
        input.value = Math.min(max, Math.max(min, current + step * direction));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }

      activateMedia(mediaId, smooth) {
        const media = this.media.find((item) => String(item.dataset.gsMedia) === String(mediaId));
        if (!media) return;

        const isMobile = window.matchMedia('(max-width: 989px)').matches;
        if (isMobile && this.track) {
          this.track.scrollTo({
            left: media.offsetLeft,
            behavior: smooth && !window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'smooth' : 'auto'
          });
        } else if (smooth) {
          media.scrollIntoView({
            block: 'center',
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
          });
        }

        this.setActiveMedia(mediaId);
      }

      setActiveMedia(mediaId) {
        let activeMedia = null;
        this.media.forEach((item) => {
          const active = String(item.dataset.gsMedia) === String(mediaId);
          item.classList.toggle('is-active', active);
          if (active) activeMedia = item;
        });
        this.mediaTargets.forEach((target) => {
          const active = String(target.dataset.gsMediaTarget) === String(mediaId);
          target.classList.toggle('is-active', active);
          if (active) target.setAttribute('aria-current', 'true');
          else target.removeAttribute('aria-current');
        });
        requestAnimationFrame(() => this.updateMobileMediaHeight(activeMedia));
      }

      updateMobileMediaHeight(media = null) {
        if (!this.track) return;

        if (!this.mobileMediaQuery?.matches) {
          this.track.style.removeProperty('height');
          return;
        }

        const activeMedia = media || this.media.find((item) => item.classList.contains('is-active')) || this.media[0];
        if (!activeMedia) return;

        const activeHeight = activeMedia.getBoundingClientRect().height;
        if (activeHeight > 0) this.track.style.height = `${Math.ceil(activeHeight)}px`;
      }

      stepMedia(direction) {
        if (!this.media.length) return;
        const activeIndex = this.media.findIndex((item) => item.classList.contains('is-active'));
        const nextIndex = Math.min(this.media.length - 1, Math.max(0, activeIndex + direction));
        this.activateMedia(String(this.media[nextIndex].dataset.gsMedia), true);
      }

      syncMediaFromScroll() {
        if (!this.track || !this.media.length) return;
        const index = Math.min(
          this.media.length - 1,
          Math.max(0, Math.round(this.track.scrollLeft / Math.max(this.track.clientWidth, 1)))
        );
        this.setActiveMedia(String(this.media[index].dataset.gsMedia));
      }
    }

    customElements.define('gs-address-product', GSAddressProduct);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
